














































import {Component, Prop, Emit} from "vue-property-decorator";
import basicPage from "@/layouts/basicPage.vue";
import SearchInput from "@/components/searchInput.vue";
import {EMPTY_ARRAY, EMPTY_OBJECT} from "@/lib/appconst";
import CBreadcrumb from "@/components/cBreadcrumb.vue";

@Component({
    name: 'searchPage',
    components: {CBreadcrumb, SearchInput, basicPage}
})
export default class searchPage extends basicPage {
    @Prop({type: String, default: ''}) title: string;
    @Prop({type: String, default: ''}) subTitle: string;
    @Prop({type: String, default: ''}) keywords: string;
    @Prop({type: Array, default: EMPTY_ARRAY}) routes: any;
    @Prop({type: Object, default: EMPTY_OBJECT}) routeTokens: any;

    basePath = '';
    defRoutes: any[] = [{
        path: 'globalList',
        breadcrumbName: '首页'
    }];

    get rRoutes() {
        return this.defRoutes.concat(this.routes);
    }

    get lastRouteName() {
        let ret = '';
        let lastRoute = this.rRoutes[this.rRoutes.length - 1];
        if (lastRoute) {
            ret = lastRoute.breadcrumbName
        }
        return ret;
    }

    //关键字搜索
    @Emit('search')
    handleSearch(inputVal: string) {
        return inputVal;
    }
}
